import { axiosInstance } from '../utils/axios';

export const getRecents = extraData =>
  axiosInstance.get('/users/me/recent', extraData);
